/* eslint-disable import/no-cycle */
import React from 'react'
import Loader from './components/common/Loader'

export const FallBackLoading = () => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
        }}
    >
        <Loader size={12} />
    </div>
)

/**
 * @description assign preload to React.lazy return
 * @param {() => Promise<{ default: React.ComponentType<Props> }} importStatement
 */
const ReactLazyPreload = (importStatement: any) =>
    Object.assign(React.lazy(importStatement), {
        preload: importStatement,
    })

/**
 * NORMAL
 */
export const AboutUsLoadable = React.lazy(() => import('./pages/AboutUs'))
export const FeatureListLoadable = React.lazy(() => import('./pages/FeaturesPage'))
export const HelpLoadable = React.lazy(() => import('./pages/Help'))
export const ConformityLoadable = React.lazy(() => import('./pages/ConformityPage'))
export const ActModuleConsultationPageLoadable = React.lazy(() => import('./pages/ActModuleConsultationPage'))
export const ActModuleTransmissionPageLoadable = React.lazy(() => import('./pages/ActModuleTransmissionPage'))
export const UserPreferencesPageLoadable = React.lazy(() => import('./pages/UserPreferencesPage'))
// disabled for now because it's unused
// export const UserPaymentsPageLoadable = React.lazy(() => import('./pages/UserPaymentsPage'))
export const StripeOnboardingPageLoadable = React.lazy(() => import('./pages/StripeOnboardingPage'))
// CGU page is wrapped with HOC, so we need to specify the type to avoid TS error
export const CGULoadable = React.lazy(() =>
    import('./pages/CGU').then((module) => ({ default: module.default as React.ComponentType<any> })),
)
export const NewsLoadable = React.lazy(() => import('./pages/NewsPage'))
export const AccountLoadable = React.lazy(() => import('./pages/AccountPage'))
export const SummaryModelLoadable = React.lazy(() => import('./pages/SummaryModelPage'))
export const LegalsLoadable = React.lazy(() => import('./pages/Legals'))
export const DmpLoadable = React.lazy(() => import('./pages/Dmp'))

/**
 * PRELOAD
 */
export const ConsultationsPageLoadable = ReactLazyPreload(() => import('./pages/consultations/ConsultationsPage'))
export const TransmissionsPageLoadable = ReactLazyPreload(() => import('./pages/transmissions/TransmissionsPage'))
export const HistoryLoadable = ReactLazyPreload(() => import('./pages/HistoryPage'))
